import { Appointment as AWAppointment } from 'lib/amwell/sdk/types';
import { CheckInStatus } from 'lib/amwell/sdk/enums';

// Types
export type Appointment = AWAppointment;

// Enums
export { CheckInStatus };

// Action Types
export interface GetAppointmentPayload {
  appointment: Appointment;
}
